import { FUSEBOX } from '@/data/api'

export const HTTP_CODE = {
  UNAUTHENTICATED: 401,
  UNPROCESSABLE_ENTITY: 422,
  PRE_CONDITIONS_FAILED: 412,
  ACCESS_DENIED: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
}
export const MENU_ROUTE_PERMISSION = 'view'

export const MESSAGE_TIMEOUT = 5000

export const MODULES = {
  DASHBOARD: 'dashboard',
  FUSEBOX: 'fuseboxes',
  USER: 'users',
  LABEL: 'labels',
  LOCATION: 'locations',
  COMPANY: 'company',
  PAYMENT: 'payment'
}

export const ROLES = {
  MANAGER: {
    ROLE_MANAGER: 'manager',
    ROLE_USER: 'user'
  },
  COMPANY: {
    ROLE_ADMIN: 'admin',
    ROLE_MANAGER: 'manager',
    ROLE_USER: 'user'
  },
  OWNER: {
    ROLE_OWNER: 'owner'
  }
}

export const PAGINATION_COUNT = 10

export const APP_CURRENCY = '\u20AC'

export const UNIT_LENGTH = 'KM'

export const FULL_FUSEBOX_URL = process.env.VUE_APP_FULL_FUSEBOX_URL || 'http://app.fusebox.dev.vps20.dolphiq.eu/'
export const SHORT_FUSEBOX_URL = process.env.VUE_APP_SHORT_FUSEBOX_URL || 'http://app.fusebox.dev.vps20.dolphiq.eu/'

export const FUSEBOX_IMAGES = {
  UPLOAD_URL: process.env.VUE_APP_API_URL + '/' + FUSEBOX.IMAGES,
  MAXIMUM_FILE_SIZE: process.env.VUE_APP_MAX_FILE_SIZE || 15,
  MAX_FILES: process.env.VUE_APP_MAX_FILES || 5
}

export const HISTORY = {
  SCANNED: 'scanned'
}

export const PAYMENT_STATUSES = {
  PENDING: 0,
  PAID: 1,
  FAILED: 2,
  CANCELED: 3,
  OPEN: 4,
  AUTHORIZED: 5,
  EXPIRED: 6
}

export const SHORT_CODE_LENGTH = 6
export const UNIVERSAL_ANALYTICS_ID = 'UA-154966297-1'
export const POPULAR_PLAN = 'exclusive-year'
export const ENTERPRISE_PLAN = 'enterprise-year'

export const BETA = false
